<template>
  <div class="data-block">
    <h3 class="data-block__title">{{ $t('view.flow.block.dataLoad.title') }}</h3>
    <div class="data-block__wrapper">
      <div class="data-block__row">
        <sw-button
          class="data-block__switch"
          v-model="storageBool"
          :label="$t('view.flow.block.dataLoad.groupStorage')"
          :onText="$t('btn.db')"
          :offText="$t('btn.cache')"
          alwaysActive
          :width="68"
          @input="onInput"
        ></sw-button>
        <in
          v-model="val.name"
          class="data-block__input"
          :label="$t('view.flow.block.dataLoad.userDataName')"
          maxlength="32"
          @input="onInput"
        ></in>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      storageBool: true,
      val: null
    }
  },
  props: ['value', 'blockId'],
  created () {
    this.val = this.value
    this.storageBool = (this.value.storage === 'database')
  },
  methods: {
    onInput () {
      this.$emit('input', this.val)
      this.$store.commit('SET_FLOW_EDIT_FLAG', [this.blockId, true])
      this.$store.commit('SET_EDITED', true)
    }
  },
  watch: {
    storageBool (act, old) {
      if (act) this.val.storage = 'database'
      else this.val.storage = 'cache'
      this.$emit('input', this.val)
    }
  }
}
</script>

<style lang="scss" scoped>
.data-block {
  @include flowElementShadow();
  width: 38%;
  min-width: 200px;
  background-color: white;
  border-radius: 7px;
  padding: 1px 14px 10px 14px;
  text-align: left;

  &__title {
    margin: 9px 0 12px 0;
    text-align: left;
  }

  &__row {
    @include alignedFlex(space-around);
    align-items: baseline;
    &:last-child {
      margin-top: 10px;
    }
  }

  &__input {
    width: 65%;
  }

  &__switch {
    width: 80px;
  }
}
</style>
